import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { PROD_LINKED_ACCOUNTS_PATH, TEST_LINKED_ACCOUNTS_PATH } from "../../../router/RouterUtils";
import PortalPageHeaderWrapper from "../../portal/PortalPageHeaderWrapper";
import CreateLinkedAccountButton from "./CreateLinkedAccountButton";
import TestLinkedAccountsPage from "./TestLinkedAccountsPage";
import { LinkedAccount } from "../../../models/Entities";

type Props = {
  isTestAccounts: boolean;
  linkedAccounts: LinkedAccount[] | undefined;
  hasNext: boolean;
  hasPrevious: boolean;
  onNext: () => void;
  onPrevious: () => void;
  onRemove: (index: number) => void;
  onRefetch: (cursor?: any) => void;
  isLoading: boolean;
  onLinkedAccountsParamsPathChange: (paramsPath: string) => void;
};

const TestLinkedAccountsTab = (props: Props) => {
  return (
    <PortalPageHeaderWrapper
      title="Linked Accounts"
      subtitle="Integrations between your users' accounts and third-party platforms"
      subtabs={[
        { label: "Production", destination: PROD_LINKED_ACCOUNTS_PATH },
        { label: "Test", destination: TEST_LINKED_ACCOUNTS_PATH },
      ]}
      buttons={<CreateLinkedAccountButton onRefetch={props.onRefetch} />}
    >
      <Switch>
        <Route
          exact
          path={TEST_LINKED_ACCOUNTS_PATH}
          children={<TestLinkedAccountsPage {...props} />}
        />
        <Redirect to={TEST_LINKED_ACCOUNTS_PATH} />
      </Switch>
    </PortalPageHeaderWrapper>
  );
};

export default TestLinkedAccountsTab;
